module.exports = __webpack_public_path__ + "img/night-canopy_en.8427f259.jpg";